import { useContext } from "react"
import { UsersContext } from "../UsersContext"

const useHeaderFilters = () => {
    const { roles, affiliations } = useContext(UsersContext)

    
    const headerFilters = [
        {
            id: 0,
            placeholder: "תפקיד",
            options: roles,
            name: "role",
            component: "autoComplete",
            labelKey: "label"
        },
        {
            id: 1,
            placeholder: "בית ספר",
            options: affiliations.data,
            name: "affiliations",
            component: "autoComplete",
            multiple: true,
        }
    ]

    return headerFilters
}

export default useHeaderFilters